/* eslint-disable */
import React from 'react';
import { IconType } from '../../types';

export const CheckedBadgeIcon = ({
  width = 24,
  height = 24,
  color = '#fff',
  backgroundColor = '#2DB295',
}: IconType) => (
  <svg
    width={width}
    height={width}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2030_612)">
      <path
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        fill={backgroundColor}
      />
    </g>
    <path
      d="M10.7933 5.18184C11.0689 4.91148 11.0689 4.47313 10.7933 4.20277C10.5176 3.93241 10.0706 3.93241 9.79498 4.20277L5.58824 8.32862L4.20502 6.972C3.92935 6.70164 3.48241 6.70164 3.20675 6.972C2.93108 7.24237 2.93108 7.68071 3.20675 7.95107L5.0891 9.79723C5.36476 10.0676 5.8117 10.0676 6.08737 9.79723L10.7933 5.18184Z"
      fill={color}
    />
    <defs>
      <clipPath id="clip0_2030_612">
        <rect width={width} height={width} fill={color} />
      </clipPath>
    </defs>
  </svg>
);
